import { Grid, Table, TableCell, TableRow, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { LegislationSocialSecurityCostDTO } from "../../../../models/legislation-social-security-cost/legislation-social-security-cost-dto";
import { StyledTableBody, StyledTableHead } from "../styles";
import SocialSecurityCostConfigurationRow from "./SocialSecurityCostConfigurationRow";

interface Props {
  socialSecurityConfig: LegislationSocialSecurityCostDTO | null;
}
const SocialSecurityCostConfiguration = ({ socialSecurityConfig }: Props) => {
  const theme = useTheme();
  return (
    <Grid style={{ padding: "8px" }}>
      <Grid style={{ display: "flex" }}>
        <Typography style={{ color: theme.palette.secondary.light }}> From Gross salary : </Typography>
        <Typography>&nbsp;{socialSecurityConfig?.fromGrossSalary.toLocaleCustom()}</Typography>
      </Grid>

      <Grid style={{ display: "flex" }}>
        <Typography style={{ color: theme.palette.secondary.light }}> To Gross salary : </Typography>
        <Typography>&nbsp;{socialSecurityConfig?.toGrossSalary.toLocaleCustom()}</Typography>
      </Grid>

      <Table stickyHeader>
        <StyledTableHead>
          <TableRow>
            <TableCell align="center">Name</TableCell>
            <TableCell align="center">Rate</TableCell>
            <TableCell align="center">Fixed amount</TableCell>
            <TableCell align="center">Cap amount | Minimum amount</TableCell>
            <TableCell align="center">Divided by | Multiplied by</TableCell>
          </TableRow>
        </StyledTableHead>
        <StyledTableBody>
          {socialSecurityConfig ? (
            socialSecurityConfig.socialSecuritySections.map((ssSection) => (
              <SocialSecurityCostConfigurationRow
                key={ssSection.id}
                ssSection={ssSection}
              />
            ))
          ) : (
            <Typography> Social security cost sections not set for this legislation</Typography>
          )}
        </StyledTableBody>
      </Table>
    </Grid>
  );
};
export default SocialSecurityCostConfiguration;
